import type { ScratchcardDetail } from '#api/shared/@types/generated/backend/graphql-schema-types'

export enum HighFrequency_OrderStatusActive {
  Pending = 'PENDING',
  Ready = 'READY',
}

export type MyOrdersScratchcardTicketCardProps = {
  serialNumber: ScratchcardDetail['serialNumber']
  status: ScratchcardDetail['status']
  winnings?: ScratchcardDetail['winningsPayload']
}
